import { useState, useMemo } from 'react'
import { InsightContentSettingType } from 'components/insightContent/types'
import { SocialWebPopularPostsWidget } from 'schemas/SocialWebPopularPostsWidgetSchema'
import { PostMetric } from 'schemas/PostMetricSchema'
import {
  addSelectionFilterToWidgetSetting,
  convertToInsightContentSetting
} from '../InsightModal/utils'

const useSelectedInsights = (
  isModalOpen: boolean,
  widgetSetting: SocialWebPopularPostsWidget,
  setIsModalOpen: (isOpen: boolean) => void
) => {
  const [selectedInsights, setSelectedInsights] = useState<PostMetric[]>([])

  const detailSetting = useMemo<InsightContentSettingType | undefined>(() => {
    if (isModalOpen && selectedInsights.length > 0) {
      return convertToInsightContentSetting(widgetSetting, {
        posts: selectedInsights
      })
    }
    return undefined
  }, [isModalOpen, widgetSetting, selectedInsights])

  const widgetSettingWithSelection = useMemo<any>(() => {
    if (isModalOpen && selectedInsights.length > 0) {
      return addSelectionFilterToWidgetSetting(widgetSetting, {
        posts: selectedInsights
      })
    }
    return undefined
  }, [isModalOpen, widgetSetting, selectedInsights])

  const handleRowClick = (targetRow: PostMetric) => {
    setSelectedInsights([targetRow])
    setIsModalOpen(true)
  }

  return { detailSetting, handleRowClick, widgetSettingWithSelection }
}

export default useSelectedInsights
